// Centralised user-facing copy for the Notifications settings feature (per
// user-facing-strings-lang-files convention) — components import from here
// rather than hardcoding literals inline.
export const notificationsLang = {
	pageHeading: "Notification Settings",
	tabPreferences: "Preferences",
	scopeSelectorLabel: "Apply to",
	scopeGlobal: "Global (all projects)",
	scopeProjectType: "Project type",
	scopeProject: "Project",
	scopeRfx: "RFx",
	projectTypePickerLabel: "Select project type",
	projectPickerLabel: "Select project",
	rfxPickerLabel: "RFx ID",
	rfxPickerPlaceholder: "Enter an RFx ID",
	matrixColumnType: "Notification type",
	matrixSecurityBadge: "Required",
	matrixLockedTooltip: (originLabel: string) => `Locked by ${originLabel} settings`,
	matrixInheritedLabel: "Inherited",
	matrixOverriddenLabel: "Overridden",
	matrixRevertToInherited: "Revert to inherited",
	matrixDigestBadge: "Digest",
	matrixImmediateBadge: "Immediate",
	matrixOffBadge: "Off",
	matrixLoadError: "Failed to load notification settings.",
	matrixRetry: "Retry",
	matrixEmpty: "No notification types are configurable at this scope.",
	saveSuccessTitle: "Settings updated",
	saveSuccessDescription: "Notification preferences have been saved.",
	saveErrorTitle: "Error",
	saveErrorDescription: "Failed to update notification preferences. Please try again.",
	digestCardHeading: "Digest Timing",
	digestCardDescription: "Choose when digest-mode notifications are sent.",
	digestSendHourLabel: "Send hour",
	digestTimezoneLabel: "Timezone",
	digestSaveButton: "Save digest settings",
	auditPageHeading: "Notification Delivery Audit",
	auditPageDescription: "Review sent and suppressed notification deliveries.",
	auditFilterUser: "Recipient",
	auditFilterType: "Type",
	auditFilterStatus: "Status",
	auditFilterContext: "Context",
	auditFilterDate: "Date",
	auditExportButton: "Export CSV",
	auditColumnRecipient: "Recipient",
	auditColumnType: "Type",
	auditColumnChannel: "Channel",
	auditColumnShaping: "Shaping",
	auditColumnStatus: "Status",
	auditColumnReason: "Reason",
	auditColumnDispatchedAt: "Dispatched",
	auditStatusSent: "Sent",
	auditStatusSuppressed: "Suppressed",
	auditStatusFailed: "Failed",
	auditEmpty: "No deliveries found for the selected filters.",
	auditPermissionDeniedCode: "403",
	auditPermissionDeniedTitle: "You don't have access to this page",
	auditPermissionDeniedMessage: "The notification delivery audit is restricted to system administrators and executives.",
} as const;

export const scopeOriginLabel: Record<string, string> = {
	global: "Global",
	project_type: "Project type",
	project: "Project",
	rfx: "RFx",
};
